import { render, staticRenderFns } from "./viewrole.vue?vue&type=template&id=0cea1fc4&scoped=true&"
import script from "./viewrole.js?vue&type=script&lang=js&"
export * from "./viewrole.js?vue&type=script&lang=js&"
import style0 from "./viewrole.vue?vue&type=style&index=0&id=0cea1fc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cea1fc4",
  null
  
)

export default component.exports